import * as React from "react";
import { Tooltip } from "../../../Tooltip";
//types
import { TitleFieldTemplateProps } from "@/src/types/components/FieldTemplates/TitleFieldTemplate";

export default function TitleFieldTemplate(props: TitleFieldTemplateProps) {
  const { id, required, title, schema, depth, detailheader } = props;

  const tooltipContent = schema?.tooltip ? schema.tooltip : null;

  let titleStyle = "text-base";
  let Tag: keyof React.JSX.IntrinsicElements = "label";

  if (depth === 0) {
    titleStyle = "text-lg font-semibold";
    Tag = "h2";
  } else if (depth === 1 && detailheader) {
    titleStyle = "text-lg font-semibold";
    Tag = "h3";
  }
  else if (depth === 2) {
    titleStyle = "text-sm font-semibold";
    Tag = "h3";
  }

  return (
    <header id={id} className="flex items-center justify-start">
      <Tag
        className={`font-bold text-primary-800 flex flex-row justify start ${titleStyle}`}
      >
        {title}
        {schema && schema.unit && ` (${schema.unit})`}{" "}
        {required && <mark className="bg-transparent">*</mark>}
      </Tag>

      {tooltipContent && <Tooltip title={tooltipContent} />}
    </header>
  );
}
